<div class="lcl-quote-header-mobile">
  <div class="lcl-quote-header-mobile-card">
    <div class="lcl-quote-header-mobile-icon">
      <img src="assets/icons/icon_vessel_dark.svg" />
    </div>
    <div class="lcl-quote-header-mobile-route">
      <div class="route-item">
        <div class="circle"></div>
        <div class="departure-line"></div>
        <span>
          <p>{{ "LABELS.FROM" | translate }}</p>
          <strong>{{ quote?.voyage?.route?.departurePort?.displayName }}</strong>
          ({{ quote?.voyage?.route?.departurePort?.unCode }}), {{ quote?.voyage?.route?.departurePort?.country?.description }}
        </span>
      </div>
      <div class="route-item">
        <div class="circle"></div>
        <div class="arrival-line"></div>
        <span>
          <p>{{ "LABELS.TO" | translate }}</p>
          <strong>{{ quote?.voyage?.route?.arrivalPort?.displayName }}</strong>
          ({{ quote?.voyage?.route?.arrivalPort?.unCode }}), {{ quote?.voyage?.route?.arrivalPort?.country?.description }}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="lcl-quote-container">
  <div class="scrollable-wrapper">
    <div class="fix-scroll">
      <div class="lcl-quote-payment-mobile">
        <app-lcl-payment-card
          [isMobileView]="true"
          [isCollapsed]="true"
          [isBooking]="true"
          [pendingBills]="pendingBills?.items"
          [pendingMarineInsuranceBills]="pendingMarineInsuranceBills"
          [productsByCompany]="productsByCompany"
          [isHasISF]="formGroup.get('isfRequested').value"
          [isHasES]="formGroup.get('entrySummaryRequested').value"
          [isHasExportLicense]="formGroup.get('exportLicenseRequested').value"
          [isBillLoading]="isBillLoading"
        ></app-lcl-payment-card>
      </div>

      <div class="container lcl-quote-wrapper">
        <div class="lcl-quote-card">
          <header class="d-none d-lg-block">
            <app-lcl-header [quote]="quote" [isHideIncoterms]="true"></app-lcl-header>
          </header>

          <section class="lcl-quote-card-body">
            <div class="row">
              <div class="col-12 col-lg-4 order-lg-1 d-none d-lg-block">
                <app-lcl-payment-card
                  [pendingBills]="pendingBills?.items"
                  [pendingMarineInsuranceBills]="pendingMarineInsuranceBills"
                  [productsByCompany]="productsByCompany"
                  [isHasISF]="formGroup.get('isfRequested').value"
                  [isHasES]="formGroup.get('entrySummaryRequested').value"
                  [isHasExportLicense]="formGroup.get('exportLicenseRequested').value"
                  [isBillLoading]="isBillLoading"
                ></app-lcl-payment-card>
              </div>

              <div class="col-12 col-lg-8 order-lg-0">
                <div class="lcl-quote-card-body-packages">
                  <app-lcl-create-quote-packages
                    [packagesFormArray]="packagesFormArray"
                    [isMobile]="!isDesktop"
                    [isSidebar]="isDesktop"
                    [isLoading]="recalcFormLoading"
                    [isQuoteEdit]="true"
                    [isInCard]="false"
                    (addPackage)="isDesktop ? addPackage() : addMobilePackage()"
                    (editPackage)="editPackage($event)"
                    (confirmPackage)="confirmPackage()"
                    (removePackage)="onRemovePackage($event)"
                  ></app-lcl-create-quote-packages>
                </div>

                <lcl-incoterms
                  [incoterms]="quote?.incoTermsType"
                  [companyShippingRole]="quote?.shippingRole"
                  (changeIncotermsSource)="setIncoterms($event)"
                  (changeShippingRole)="setShippingRole($event)"
                ></lcl-incoterms>

                <div class="lcl-quote-notification-wrapper">
                  <div class="lcl-quote-notification">
                    <div class="lcl-quote-notification-icon">
                      <span class="icon-ic_big_a"></span>
                    </div>

                    <div class="lcl-quote-notification-text">
                      {{ "LCL_SHIPMENT.QUOTE.CREATE.HINT" | translate }}
                    </div>
                  </div>
                </div>

                <app-lcl-edit-additional-options
                  [formGroup]="formGroup"
                  [quote]="quote"
                  [isInsuranceAvailable]="isInsuranceAvailable"
                  [isInsuranceLoading]="isInsuranceLoading"
                  [currentInsurance]="currentInsurance"
                  [marineInsuranceRequested]="marineInsuranceRequested"
                  [isVoyageValidForInsurance]="isVoyageValidForInsurance"
                  (optionISFUpdated)="onOptionISFUpdated($event)"
                  (optionESUpdated)="onOptionESUpdated($event)"
                  (optionExportLicenseUpdated)="onOptionExportLicenseUpdated($event)"
                  (optionMarineInsuranceUpdated)="onOptionMarineInsuranceUpdated($event)"
                ></app-lcl-edit-additional-options>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <app-lcl-footer [isFixed]="true">
    <ng-container footer>
      <button class="btn btn-primary" (click)="onSubmit()">
        {{ "BUTTON.BOOK_NOW" | translate }}
      </button>
    </ng-container>
  </app-lcl-footer>
</div>
